import { Component, Prop, Vue } from 'vue-property-decorator'
// import Control from '@/helpers/control'
import getStyle from '@/helpers/getStyle'
// import LabelModified from '@/components/edit/LabelModified/index.vue'
// import BadgeClient from '@/components/checking-accounts/BadgeClient/index.vue'

// import FieldMoneyPortal from '@/components/edit/FieldMoneyPortal/index.vue'
// import FieldPercentagePortal from '@/components/edit/FieldPercentagePortal/index.vue'
// import FieldDatePortal from '@/components/edit/FieldDatePortal/index.vue'
import TableBodyContent from './TableBodyContent/index.vue'
// import onInputCheckingAccounts from '@/views/CheckingAccounts/onInputCheckingAccounts'

// import tableHelper from '@/helpers/table'

import { faPen } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'

library.add(faPen)

@Component({
	components: {
		// LabelModified,
		// BadgeClient,
		// FieldMoneyPortal,
		// FieldPercentagePortal,
		// FieldDatePortal,
		TableBodyContent,
	},
})
export default class TableBody extends Vue {
	@Prop() items
	@Prop() fields
	@Prop() onEdit
	@Prop() onDelete

	getStyle = getStyle

	getFieldValue(item, fieldName) {
		let result: any = ''

		result = item[fieldName]

		if (typeof result === 'object') {
			result = result?.name || result
		}

		return result
	}
}
